import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const Svg = styled.svg`
  height: ${({ size, height }) => height || `${size}px`};
  width: ${({ size, width }) => width || `${size}px`};
  fill: ${({ color }) => color};

  &:hover {
    fill: ${({ colorHover }) => colorHover};
    color: ${({ colorHover }) => colorHover};
  }
`;

const Icon = ({
  icon,
  size = '15',
  height,
  width,
  color = 'inherit',
  className,
  colorHover,
  ...rest
}) => (
  <Svg
    size={size}
    height={height}
    width={width}
    icon={icon}
    color={color}
    className={className}
    colorHover={colorHover}
    {...rest}
  >
    <use xlinkHref={`sprite.svg#icon-${icon}`} />
  </Svg>
);

Icon.propTypes = {
  size: PropTypes.string,
  width: PropTypes.string,
  color: PropTypes.string,
  icon: PropTypes.string.isRequired,
  className: PropTypes.string,
  height: PropTypes.string,
  colorHover: PropTypes.string,
};

export default Icon;
